// extracted by mini-css-extract-plugin
module.exports = {"icon":"_61cc05a7c9--icon--2XmmP","popup":"_61cc05a7c9--popup--2Djy2"};